// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.12.4
//   protoc               unknown
// source: qonto/registration/legal_entities/firstparty/v1/legal_entity.proto

/* oxlint-disable */

/** LegalEntity represents a legal entity associated with an organization */
export interface ApiLegalEntity {
  /** Unique identifier of the legal entity */
  readonly id: string;
  /** Type of the resource (always "legal_entities") */
  readonly type: string;
  /** Attributes of the legal entity */
  readonly attributes: ApiLegalEntityAttributes | null;
}

/** Attributes of a legal entity */
export interface ApiLegalEntityAttributes {
  /** Legal name of the legal entity */
  readonly legalName: string;
  /** Registration number of the legal entity */
  readonly legalNumber?:
    | string
    | null
    | undefined;
  /** Share capital amount contributed by the legal entity (in euros) */
  readonly capitalAmount?: number | null | undefined;
}

export const ApiLegalEntity: MessageFns<ApiLegalEntity> = {
  fromJSON(object: any): ApiLegalEntity {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      type: isSet(object.type) ? globalThis.String(object.type) : "",
      attributes: isSet(object.attributes) ? ApiLegalEntityAttributes.fromJSON(object.attributes) : null,
    };
  },

  toJSON(message: ApiLegalEntity): unknown {
    const obj: any = {};
    if (message.id !== undefined && message.id !== null) {
      obj.id = message.id;
    }
    if (message.type !== undefined && message.type !== null) {
      obj.type = message.type;
    }
    if (message.attributes !== undefined && message.attributes !== null) {
      obj.attributes = ApiLegalEntityAttributes.toJSON(message.attributes);
    }
    return obj;
  },
};

export const ApiLegalEntityAttributes: MessageFns<ApiLegalEntityAttributes> = {
  fromJSON(object: any): ApiLegalEntityAttributes {
    return {
      legalName: isSet(object.legal_name) ? globalThis.String(object.legal_name) : "",
      legalNumber: isSet(object.legal_number) ? globalThis.String(object.legal_number) : null,
      capitalAmount: isSet(object.capital_amount) ? globalThis.Number(object.capital_amount) : null,
    };
  },

  toJSON(message: ApiLegalEntityAttributes): unknown {
    const obj: any = {};
    if (message.legalName !== undefined && message.legalName !== null) {
      obj.legal_name = message.legalName;
    }
    if (message.legalNumber !== undefined && message.legalNumber !== null) {
      obj.legal_number = message.legalNumber;
    }
    if (message.capitalAmount !== undefined && message.capitalAmount !== null) {
      obj.capital_amount = message.capitalAmount;
    }
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
